import { useEffect } from "react";
import "./LandingPage.css";

const LandingPage = () => {
  useEffect(() => {
    document.title = "PharmaSwiss Web Portal";
  }, []);

  return (
    <div className="body">
      <header>
        <a href="https://www.pharmaswiss.rs/" target="_blank" rel="noreferrer">
          <img
            class=""
            src="Images/imagePharmaswissLogo.webp"
            alt="PharmaSwiss logo"
          />
        </a>
      </header>

      <main>
        <div class="launchpad">
          <div class="grid">
            <a
              href="https://softlab4pharmaswiss.blob.core.windows.net/bistro/app/publish.htm"
              target="_blank"
              rel="noreferrer"
              class="card-link"
            >
              <div class="card">
                <img
                  src="Images/imageDownload.webp"
                  alt="BISTRO application icon"
                />
                <span>BISTRO</span>
              </div>
            </a>

            <a
              href="https://apps.powerapps.com/play/e/default-a72dda32-ee80-4da8-a3ac-ec0e9e41a50a/a/ea0302e7-f0d1-4535-ac7e-424c1e93e647?tenantId=a72dda32-ee80-4da8-a3ac-ec0e9e41a50a&hint=c79415f3-ed86-4160-91c4-745df91a5f4d&sourcetime=1770724896033&source=portal"
              target="_blank"
              rel="noreferrer"
              class="card-link"
            >
              <div class="card">
                <img
                  src="Images/imageKOMPAS.webp"
                  alt="KOMPAS application icon"
                />
                <span>KOMPAS</span>
              </div>
            </a>

            <a
              href="https://bistro.softlab.rs/sales"
              target="_blank"
              rel="noreferrer"
              class="card-link"
            >
              <div class="card">
                <img src="Images/imageSales.webp" alt="Sales report icon" />
                <span>SALES</span>
              </div>
            </a>

            <a
              href="https://bistro.softlab.rs/protocol"
              target="_blank"
              rel="noreferrer"
              class="card-link"
            >
              <div class="card">
                <img
                  src="Images/imageProtocol.webp"
                  alt="Protocol report icon"
                />
                <span>PROTOCOL</span>
              </div>
            </a>

            <a
              href="https://activitybudget.azurewebsites.net/"
              target="_blank"
              rel="noreferrer"
              class="card-link"
            >
              <div class="card">
                <img
                  src="Images/imageActivityBudget.webp"
                  alt="Activity Budget application icon"
                />
                <span>ACTIVITY BUDGET</span>
              </div>
            </a>

            <a
              href="https://commercialaccrualtracking.azurewebsites.net/"
              target="_blank"
              rel="noreferrer"
              class="card-link"
            >
              <div class="card">
                <img src="Images/imageCAT.webp" alt="CAT application preview" />
                <span>CAT</span>
              </div>
            </a>
          </div>
        </div>
        <div>
          <a
            href="https://www.bauschhealth.com/"
            target="_blank"
            rel="noreferrer"
          >
            <img
              class="bottom-logo"
              src="Images/imageBauschHealthLogo.webp"
              alt="BauschHealth logo"
            />
          </a>
        </div>
      </main>

      <div className="footer">
        Copyright © {new Date().getFullYear()}. &nbsp;{" "}
        <a href="https://softlab.rs" target="_blank" rel="noreferrer">
          <img
            class="image-soft-lab-logo"
            src="Images/imageSoftLabLogo.webp"
            alt="SoftLab Logo"
          />
        </a>
        &nbsp; All rights reserved.
      </div>
    </div>
  );
};

export default LandingPage;
